import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class Tag extends Model<Schemas['tags'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }

    /** The tag's name followed by its synonyms. */
    get names() {
        return [this.name, ...(this.synonyms || [])];
    }

    get displayName() {
        return this.name;
    }

    get abbreviatedName() {
        return this.displayName.replace(' Medicine', '');
    }
}
